var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Carousel',{attrs:{"tip":"加入","args":_vm.args.slide}}),_c('OurAdvantage'),_c('CampusDecoration'),_c('OperationManual'),_c('Join'),_c('JoinNow',{attrs:{"args":_vm.args.join_now}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }